import Mock from 'mockjs'

const MOCK050021 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'orderNo': '@id',
        'orderStatus': '01',
        'orderStatusDisp': '待供应商确认订单',
        'purchaserName': '@cword(5)',
        'purchaserContactName': '@cword(5)',
        'purchaserContactMobile': '13800000000',
        'purchaserCorpAddr': '@ctitle',
        'purchaserBusiLicense': '@id',

        'supplierName': '',
        'supplierContactName': '@cword(5)',
        'supplierContactMobile': '13800000000',
        'supplierCorpAddr': '@ctitle',
        'supplierBusiLicense': '@id',

        'orderAcctName': '@cword(5)',
        'orderTime': '@datetime',
        'itemCount|1000-5000': 1000,
        'orderAmountTotal|20000-100000': 20000,
        'consigneeAddr': '@county(true)',
        'consigneeName': '@cname',
        'consigneeMobile': '13800000000',
        'orderList|5-10': [{
            'skuId': '@id',
            'attachUrl': '@image("600x600",@color)',
            'skuName': '@cword(15)',
            'model': '@cword(5)',
            'price|100000-500000': 100000,
            'buyCount|200-500': 200,
            'totalAmt|200-1000': 200,
            'deliveredCount|100-500': 100,
            'signedCount|100-500': 100,
        }]
    }
});

export default MOCK050021


// WEBPACK FOOTER //
// ./src/mock/getOrderDetail.js